import React from "react";

import GoldLockLogo from "../../../assets/gold-lock.png";
// import MastercardLogo from "../../../assets/mastercard_logo.png";
import FinicityLogo from "../../../assets/FinicityMastercard.png";
import PlaidLogo from "../../../assets/Plaid.svg";

const PartnerBanner = ({ isLockLogoVisible = true }) => {
  return (
    <>
      {isLockLogoVisible && (
        <div
          style={{ backgroundColor: "whitesmoke" }}
          className="flex text-sm flex-row items-center justify-center px-4 py-4 mt-5 text-gray-600"
        >
          <span>
            We'll never share your data with third parties.<br /> Your data is secured  
            and encrypted <span role="img" aria-label="lock-emoji">🔒 </span> by Mastercard.
          </span>
        </div>
      )}
      <div className="flex flex-col items-center justify-center mt-10">
        <span className="font-bold text-lg">Secured By:</span>
        <div className="flex flex-row items-center justify-center gap-5">
          <img className="h-10 mx-1" src={FinicityLogo} />
          <img className="h-16 w-16 mx-1" src={PlaidLogo} />
        </div>
      </div>
    </>
  );
};

export default PartnerBanner;
